import MainButton from 'components/Buttons/MainButton'
import { FaStar } from 'react-icons/fa'
import { Form, Title, InfoText } from '../styles'

export default function RatingComplete ({ onConfirm: handleConfirm }) {
  return (
    <Form>
      <Title>Avaliações enviadas</Title>
      <FaStar color='#FFC100' size={50}/>
      <InfoText style={{marginTop: 10}}>
        {'Obrigado por avaliar seu atendimento! '
        + 'Suas avaliações ajudam outros clientes a escolherem os melhores salões e profissionais, '
        + 'além de incentivar os estabelecimentos a oferecerem um serviço cada vez melhor.'}
      </InfoText>
      <MainButton
        label='Fechar'
        type='button'
        width={140}
        onClick={handleConfirm}
      />
    </Form>
  )
}
